import { frontendURL } from 'dashboard/helper/URLHelper';
import { ROLES } from 'dashboard/constants/permissions';

const InternalChatPage = () => import('./InternalChatPage.vue');

export const routes = [
  {
    path: frontendURL('accounts/:accountId/internal-chat'),
    name: 'internal_chat',
    component: InternalChatPage,
    meta: {
      permissions: [...ROLES, 'custom_role'],
    },
  },
];
